export enum TicketsTabKeyEnum {
  Active = 'active',
  All = 'all',
}
